(function () {
	'use strict';

	angular.module('qbePortal').directive('uiSelectRequired', ['validationService',
		function (validationService) {

			return {
				require: 'ngModel',
				link: function (scope, element, attrs, ctrl) {

					var formIsSubmitted = false;

					scope.$on('broadcast-field-errors', function () {
						formIsSubmitted = true;
					});

					scope.$on('reset-field-errors', function () {
						formIsSubmitted = true;
					});

					ctrl.$validators.uiSelectRequired = function (modelValue, viewValue) {
						if (!modelValue || !modelValue.$select)
							return true;

						var value = ( modelValue.$select ) ? modelValue.$select.selected : null;
						var valid = value !== undefined;
						validationService.validateInput(element, ctrl, attrs.labelKey);

						if (valid) {
							if (ctrl.$error.required)
								delete ctrl.$error.required;
						} else {
							ctrl.$error.required = true;
						}

						if (ctrl.$error.uiSelectRequired)
							delete ctrl.$error.uiSelectRequired;

						var parent = element.parents('div.ctrl-holder');
						if (!parent || !parent[0]) return;
						parent = $(parent).first();

						if (valid) {
							parent.removeClass('is-error');
						} else if (ctrl.$dirty || formIsSubmitted) {
							parent.addClass('is-error');
						}

						return valid;
					};

					scope.$watch(ctrl.$validators.uiSelectRequired);
				}
			};
		}])
})();
